/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react'; // Importing React and useState to manage local state
import { Box } from "@mui/material"; // Importing Box from MUI to structure the UI
import CustomModal from "../../../../../components/Modal/CustomModal"; // Importing the custom modal component
import { CustomTextField } from "../../../../../components/CustomTextField"; // Importing the custom text field component
import { CustomSelect } from "../../../../../components/CustomSelect"; // Importing the custom select component
import { CustomCheckbox } from "../../../../../components/CustomCheckbox"; // Importing the custom checkbox component
import { FILE_TYPE } from "../../../../../Helpers/fileType"; // Importing constants related to file types
import AddDocumentApp from "../Functionality/AddDocumentApp";
import {ACTION_MODEL} from "../../../../../Helpers/ActionModel";
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import {size50MB} from '../../../../../constant/variable'; // Importing the constant that defines the max file size

const AddDocumentModal = (props) => {
    const {action} = props;
    const { t,
        activeStep,
        documentName,
        setDocumentName,
        departmentId,
        setDepartmentId,
        isCompanyDoc,
        setIsCompanyDoc,
        instruction,
        setInstruction,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        getAllDepartments,
        handleCreateDocument,
        reset,
        handleDeletePhotoPicker,
        displayModal,
        setDisplayModal,
    } = AddDocumentApp(props);

    return (
        // Custom modal receiving required props
        <CustomModal
            {...props} // Spreading props to the modal
            size="lg" // Modal size
            display={displayModal}
            buttonConfirm={ // Text for button confirm
                action === ACTION_MODEL.UPDATE ? "update": "create"
            }
            cancelButton={ action !== ACTION_MODEL.READ} // Enable cancel button
            confirmButton={action !== ACTION_MODEL.READ} // Enable confirm button
            onConfirm={() => {
                if(action === ACTION_MODEL.READ){
                    reset();
                    return;
                }
                handleCreateDocument();
            }}
            onHide={reset} // Function to execute on modal close
            classNameBody="pt-2"
        >
            {/* Form description */}
            <div className={"row"}>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    {/* Text field for document name */}
                    <CustomTextField
                        id={"txt_adm_document_name"}
                        length={100}
                        name={"documentName"}
                        value={documentName}
                        trans={"document_name"}
                        type={"text"}
                        onChange={(e) => setDocumentName(e.target.value)} // Update state with input value
                        required={true}
                        emptyFields={emptyFields} // Show error if field is empty
                        disabled={disabled}
                    />
                </div>
                <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    {/* Department select field */}
                    <CustomSelect
                        id={"slt_adm_department"}
                        name={"departmentId"}
                        value={departmentId}
                        keyName="id"
                        onChange={(e) => setDepartmentId(e.target.value)} // Update selected department
                        list={getAllDepartments} // List of available departments
                        trans={"department"}
                        label={"lbl_adm_department"}
                        required={false}
                        helperText={t("department_who_can_approve_it,_leave_empty_in_case_anyone")} // Help text
                        disabled={disabled}
                    />
                </Box>

                {/* Show checkbox only for supplier or contractor step */}
                {(activeStep === 1 || activeStep === 2) && (
                    <Box className='col-12'>
                        <CustomCheckbox
                            id={"cb_adm_is_company_doc"}
                            trans={"company_document"}
                            name={"companyDocument"}
                            checked={isCompanyDoc}
                            value={isCompanyDoc}
                            onChange={(e) => setIsCompanyDoc(e.target.checked)} // Update checkbox state
                            helperText={t('just_is_required_for_the') + " " +
                            ((activeStep === 1 && t('Supplier')) ||
                                (activeStep === 2 && t('contractor')) ||
                                (activeStep === 0 && t('employee'))) + " "+ t('in_charge_leave_in_blank_for_anyone')}
                            disabled={disabled}
                        />
                    </Box>
                )}

                {/* Text field for additional instructions */}
                <Box className='col-12'>
                    <CustomTextField
                        id={"txt_adm_instruction"}
                        length={500}
                        name={"instruction"}
                        value={instruction}
                        trans={"instruction"}
                        type={"text"}
                        onChange={(e) => setInstruction(e.target.value)} // Update instructions
                        required={false}
                        multiline={true} // Allow multiple lines
                        disabled={disabled}
                    />
                </Box>

                {/* File upload component */}
                <Box className={"col-12"}>
                    { (action === ACTION_MODEL.UPDATE || action === ACTION_MODEL.READ ) ?
                        <CustomPhotoPicker
                            id='fu_cn_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.UPDATE}
                            accept={{ ...FILE_TYPE.FILES}} // Accepted file types and size limit
                            classWith={'w-100'}
                            disabled={disabled}
                            showPreview={false}
                            handleDelete={ photoPicker?.previewImage != null ? () => handleDeletePhotoPicker() : undefined}
                            setDisplayModal={setDisplayModal}
                        />
                        :
                        <CustomPhotoPicker
                            id='fu_cn_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.FILES }} // Accepted file types and size limit
                            classWith={'w-100'}
                            disabled={disabled}
                            showPreview={false}
                        />
                    }
                </Box>
            </div>
        </CustomModal>
    );
};

export default AddDocumentModal; // Exporting the component for use in other parts of the application
